// extracted by mini-css-extract-plugin
export default {"deleteButton":"EditStep_deleteButton__EiWg+","field":"EditStep_field__6oIHi","fieldCheckbox":"EditStep_fieldCheckbox__Udy5K","text":"EditStep_text__er-XC"};